// extracted by mini-css-extract-plugin
export default {"container":"GPACalculator_container__AO7zm"};